import { bindable } from 'aurelia-framework';

enum InfoState {
    Visible = 1,
    Dismissing,
    Dismissed
};

export class EssInfoCustomElement {

    InfoState = InfoState;

    @bindable() dismissible: boolean = true;

    state: InfoState = InfoState.Visible;

    attached() {
        this.state = InfoState.Visible;
    }

    hide() {
        //debugger;
    }

    transitionEnd() {
        if(this.state == InfoState.Dismissing) {
            this.state = InfoState.Dismissed;
        }
    }
}
